module.exports = __webpack_public_path__ + "img/HeroImage.faffd037.png";